import { render } from "./HomePage.vue?vue&type=template&id=55b18d38"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=55b18d38&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__